import { API_BASE } from './apiBase';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [isResetMode, setIsResetMode] = useState(false);
  const [errorEmail, setErrorEmail] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate();

  // On page load, check if an email was saved previously
  React.useEffect(() => {
    const savedEmail = localStorage.getItem('savedEmail');
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const resetErrorsAndMessages = () => {
    setErrorEmail('');
    setErrorPassword('');
    setSuccessMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    resetErrorsAndMessages();
    setIsLoading(true);

    console.log('[LOGIN] Form submitted. Mode:', isResetMode ? 'Reset' : 'Normal');
    console.log('[LOGIN] Payload:', { email, password: password ? '***' : 'missing' });

    try {
      if (isResetMode) {
        console.log('[RESET] Sending reset request...');
        await axios.post(`${API_BASE}/reset-password`, {
          email,
          oldPassword: password,
          newPassword,
        });
        setSuccessMessage('Password update confirmed!');
        setPassword('');
        setNewPassword('');
        setTimeout(() => {
          setIsResetMode(false);
          setSuccessMessage('');
        }, 3000);
      } else {
        console.log('[LOGIN] Sending login request to /login');
        const res = await axios.post(`${API_BASE}/login`, { email, password });
        console.log('[LOGIN] Full success response from backend:', res.data);

        // FIXED: Match the actual backend response structure
        const { token, user } = res.data;

        if (!token || !user) {
          throw new Error('Invalid response from server');
        }

        localStorage.setItem('token', token);
        localStorage.setItem('userId', user.id || user._id || '');
        localStorage.setItem('name', user.name || '');
        localStorage.setItem('role', user.role || 'employee');
        localStorage.setItem('hasInventoryAccess', user.hasInventoryAccess ? 'true' : 'false');

        // Save or clear the email based on the checkbox
        if (rememberMe) {
          localStorage.setItem('savedEmail', email);
        } else {
          localStorage.removeItem('savedEmail');
        }

        console.log('[LOGIN] Successfully stored in localStorage:', {
          token: !!token,
          name: user.name,
          role: user.role,
          hasInventoryAccess: user.hasInventoryAccess
        });

        navigate('/');
      }
    } catch (err) {
      console.error('[LOGIN/RESET] FULL ERROR:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });

      if (isResetMode) {
        if (err.response?.data?.error === 'User not found') setErrorEmail('Incorrect email');
        else if (err.response?.data?.error === 'Incorrect old password') setErrorPassword('Incorrect password');
        else alert('Server error');
      } else {
        const data = err.response?.data || {};
        if (data.locked) {
          // Account locked after 3 strikes (super admins get an email link).
          setErrorPassword(data.error);
        } else if (typeof data.attemptsLeft === 'number') {
          setErrorPassword(`Incorrect password — ${data.attemptsLeft} attempt${data.attemptsLeft === 1 ? '' : 's'} left before lockout`);
        } else {
          setErrorPassword(data.error || 'Invalid credentials');
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>{isResetMode ? 'Reset Password' : 'Login'}</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: '300px', margin: '30px auto', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          className="max-md:!text-base"
          style={{ padding: '12px', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        {errorEmail && <p style={{ margin: 0, color: 'red', fontSize: '10px' }}>{errorEmail}</p>}

        <input
          type="password"
          placeholder={isResetMode ? 'Old Password' : 'Password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          className="max-md:!text-base"
          style={{ padding: '12px', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        {errorPassword && <p style={{ margin: 0, color: 'red', fontSize: '10px' }}>{errorPassword}</p>}
        {!isResetMode && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: 'gray', cursor: 'pointer', textAlign: 'left', marginTop: '-4px', marginBottom: '4px' }}>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={{ cursor: 'pointer' }}
            />
            Remember my email
          </label>
        )}
        {isResetMode && (
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            autoComplete="new-password"
            className="max-md:!text-base"
            style={{ padding: '12px', borderRadius: '6px', border: '1px solid #ccc' }}
          />
        )}

        <button
          type="submit"
          disabled={isLoading}
          style={{ padding: '12px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
        >
          {isResetMode ? 'Confirm Reset' : 'Login'}
        </button>

        {successMessage && <p style={{ marginTop: '10px', color: 'green', fontSize: '12px', fontWeight: 'bold' }}>{successMessage}</p>}
      </form>

      {!isResetMode && (
        <div
          onClick={() => setIsResetMode(true)}
          className="max-md:!text-sm max-md:py-3"
          style={{ marginTop: '10px', fontSize: '10px', color: 'gray', cursor: 'pointer' }}
          onMouseOver={(e) => (e.currentTarget.style.color = '#007bff')}
          onMouseOut={(e) => (e.currentTarget.style.color = 'gray')}
        >
          Reset password
        </div>
      )}

      {isResetMode && (
        <div
          onClick={() => setIsResetMode(false)}
          className="max-md:!text-sm max-md:py-3"
          style={{ marginTop: '10px', fontSize: '10px', color: 'gray', cursor: 'pointer' }}
          onMouseOver={(e) => (e.currentTarget.style.color = '#007bff')}
          onMouseOut={(e) => (e.currentTarget.style.color = 'gray')}
        >
          ← Back to Login
        </div>
      )}
    </div>
  );
}

export default Login;